import React from "react";
import { Link } from "react-router-dom";


function TreeOrderPaymentSuccessful() {
  return (
    <div className="main-wrapper d-flex align-items-center justify-content-center vh-100">
      <div className="card shadow-lg text-center p-5" style={{ maxWidth: "500px", borderRadius: "20px" }}>
        
        {/* Success Icon */}
        <div className="mb-4">
         
        </div>

        {/* Title */}
        <h3 className="fw-bold text-success">Payment Successful 🎉</h3>

        {/* Message */}
        <p className="text-muted mt-3">
          Thank you for the order! Your order will be processed.  
          
        </p>

        
      </div>
    </div>
  );
}

export default TreeOrderPaymentSuccessful;
